<div class="{{ classNames }}">
  <div class="text-xs text-dark-gray">{{ label }}</div>
  <div class="mt-2"><ng-content></ng-content></div>
</div>
